// src/redux/slices/ptoSlice.js
import { createSlice } from "@reduxjs/toolkit";

// Note: API operations have been moved to UserPageContainer for centralized management
// This slice now only handles local state management for PTO data

export const ptoSlice = createSlice({
  name: 'pto',
  initialState: {
    ptoEntries: [],
    status: 'idle',
    error: null
  },
  reducers: {
    // Local actions for fallback or offline functionality
    setPtoEntries: (state, action) => {
      state.ptoEntries = action.payload;
      state.status = 'succeeded';
      state.error = null;
    },
    addPtoEntry: (state, action) => {
      // Generate a unique ID for the new entry
      const id = Date.now().toString();
      state.ptoEntries.push({
        id,
        ...action.payload,
      });
    },
    editPtoEntry: (state, action) => {
      const { id, ...updatedData } = action.payload;
      const entryIndex = state.ptoEntries.findIndex(entry => entry.id === id);
      if (entryIndex !== -1) {
        state.ptoEntries[entryIndex] = {
          ...state.ptoEntries[entryIndex],
          ...updatedData
        };
      }
    },
    removePtoEntry: (state, action) => {
      state.ptoEntries = state.ptoEntries.filter(entry => entry.id !== action.payload);
    },
    clearAllPto: (state) => {
      state.ptoEntries = [];
    },
    setPtoLoading: (state) => {
      state.status = 'loading';
      state.error = null;
    },
    setPtoError: (state, action) => {
      state.status = 'failed';
      state.error = action.payload;
    }
  }
});

// Export actions
export const { 
  setPtoEntries,
  addPtoEntry, 
  editPtoEntry, 
  removePtoEntry,
  clearAllPto,
  setPtoLoading,
  setPtoError
} = ptoSlice.actions;

// Selectors
export const selectPtoEntries = (state) => state.pto.ptoEntries;
export const selectPtoStatus = (state) => state.pto.status;
export const selectPtoError = (state) => state.pto.error;
export const selectEngineerPtoEntries = (state, engineerId) => 
  state.pto.ptoEntries.filter(entry => entry.engineerId === engineerId);

export default ptoSlice.reducer;